function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M15.052,3.865h-.622V2.622A.622.622,0,0,0,13.809,2h-8.7a.622.622,0,0,0-.622.622V3.865H3.865A1.865,1.865,0,0,0,2,5.729v.622A1.865,1.865,0,0,0,3.865,8.215h.785a4.982,4.982,0,0,0,2.945,3.363v1.61H6.972a1.865,1.865,0,0,0-1.865,1.865V16.3a.622.622,0,0,0,.622.622h7.459a.622.622,0,0,0,.622-.622V15.052a1.865,1.865,0,0,0-1.865-1.865h-.622V11.58a4.993,4.993,0,0,0,2.952-3.364h.777a1.865,1.865,0,0,0,1.865-1.865V5.729A1.865,1.865,0,0,0,15.052,3.865ZM3.865,6.972a.622.622,0,0,1-.622-.622V5.729a.622.622,0,0,1,.622-.622h.622V6.972Zm8.7,8.08v.622H6.351v-.622a.622.622,0,0,1,.622-.622h4.972A.622.622,0,0,1,12.566,15.052ZM10.08,13.188H8.837V11.9a4.461,4.461,0,0,0,1.243,0ZM9.459,10.7A3.729,3.729,0,0,1,5.729,6.972V3.243h7.459V6.972A3.729,3.729,0,0,1,9.459,10.7Zm6.215-4.351a.622.622,0,0,1-.622.622h-.622V5.108h.622a.622.622,0,0,1,.622.622Z",
  transform: "translate(-2 -2)"
});

var SvgTrophy = function SvgTrophy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14.917,
    height: 14.917,
    viewBox: "0 0 14.917 14.917",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrophy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trophy.688bf002.svg";
export { ForwardRef as ReactComponent };